import React from 'react';
import { UsersIcon, StarIcon } from 'lucide-react';
export function SocialProofSection() {
  return <section className="py-12 px-4 bg-white border-y border-warm-400" data-id="element-169">
      <div className="max-w-4xl mx-auto" data-id="element-170">
        <div className="bg-cream-dark/50 rounded-2xl p-8 md:p-10 border border-primary/20 relative overflow-hidden" data-id="element-171">
          {/* Decorative quote mark */}
          <div className="absolute -top-4 -left-2 text-8xl text-primary/10 font-serif leading-none select-none" data-id="element-172">
            "
          </div>

          <div className="flex flex-col items-center text-center relative z-10" data-id="element-173">
            <div className="flex gap-1 mb-6" data-id="element-174">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 fill-primary text-primary" data-id="element-175" />)}
            </div>

            <p className="text-xl md:text-2xl text-warm-900 leading-relaxed font-medium mb-6" data-id="element-176">
              "Miles de personas ya están aprovechando su Air Fryer para cocinar
              comidas increíbles en minutos. Personas que antes no tenían tiempo
              para cocinar ahora disfrutan platos caseros más saludables sin
              complicarse."
            </p>

            <div className="flex items-center gap-3 text-warm-700 font-medium" data-id="element-177">
              <div className="bg-primary/15 p-2 rounded-full" data-id="element-178">
                <UsersIcon className="w-5 h-5 text-primary" data-id="element-179" />
              </div>
              <span data-id="element-180">+2,847 personas ya tienen su copia</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}